var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMIconNavTrackingGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87409 14.9994C6.02537 14.9994 5.22291 14.6738 4.61731 14.0825L2.02242 11.6964C0.71497 10.3946 0 8.67526 0 6.84596C0 5.01667 0.715595 3.29736 2.01429 2.00429C3.31236 0.711845 5.03792 0 6.87409 0C8.71026 0 10.4358 0.711845 11.7345 2.00492C13.0332 3.29799 13.7488 5.01792 13.7488 6.84659C13.7488 8.67526 13.0332 10.3952 11.7345 11.6883L9.12462 14.0894C8.52465 14.6744 7.7228 15 6.87346 15L6.87409 14.9994ZM6.87409 0.624974C5.20478 0.624974 3.63485 1.27245 2.45427 2.44802C1.27432 3.62297 0.624349 5.18478 0.624349 6.84659C0.624349 8.5084 1.27432 10.0702 2.45427 11.2452L5.04667 13.6288C6.03787 14.595 7.71593 14.5888 8.69526 13.6351L11.3027 11.2364C12.4739 10.0702 13.1238 8.50777 13.1238 6.84659C13.1238 5.18541 12.4739 3.62297 11.2939 2.44802C10.1127 1.27245 8.54339 0.624974 6.87409 0.624974ZM6.59848 8.47652L10.5314 4.59731C10.6539 4.47606 10.6552 4.27857 10.5346 4.15545C10.4121 4.03233 10.2146 4.03108 10.0921 4.15233L6.15787 8.03279C6.03725 8.15466 5.83726 8.15466 5.71289 8.02967L3.65485 6.02537C3.53298 5.906 3.33424 5.90788 3.21299 6.03162C3.093 6.15537 3.0955 6.35286 3.21924 6.47348L5.27416 8.47465C5.45727 8.65776 5.69726 8.74901 5.93788 8.74901C6.17724 8.74901 6.41723 8.65776 6.5991 8.4759L6.59848 8.47652Z",
    fill: "url(#paint0_radial_671_87852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_671_87852",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6483 3.52041) rotate(-34.4228) scale(30.3255 16.749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIconNavTrackingGradient);
export default __webpack_public_path__ + "static/media/m-icon-nav-tracking-gradient.ea31c303b6438a410b4da623ed00267a.svg";
export { ForwardRef as ReactComponent };